import { render, staticRenderFns } from "./s-detail.vue?vue&type=template&id=6e33f284&"
import script from "./s-detail.vue?vue&type=script&lang=js&"
export * from "./s-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports